import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error('Las contraseñas no coinciden');
    
    setLoading(true);
    try {
      await api.post(`/auth/reset-password/${token}`, { password });
      toast.success('Contraseña actualizada con éxito ✅');
      nav('/');
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Error al restablecer contraseña');
    } finally { setLoading(false); }
  };

  return (
    <div className="page-wrap flex items-center justify-center min-h-[60vh]">
      <div className="card shadow-lg animate-fade-up max-w-[450px] w-full p-10">
         <h2 className="text-center font-fraunces mb-2">🔑 Elige tu nueva clave</h2>
         <p className="text-center text-txs text-sm mb-8">Ingresa tu nueva contraseña para recuperar el acceso a tu cuenta.</p>
         
         <form onSubmit={handleSubmit}>
           <div className="form-group">
              <label>Nueva Contraseña</label>
              <input 
                className="input" 
                type="password" 
                placeholder="Mínimo 6 caracteres" 
                value={password} 
                onChange={e => setPassword(e.target.value)} 
                required 
                minLength={6}
              />
           </div>
           <div className="form-group mt-5">
              <label>Confirmar Contraseña</label>
              <input 
                className="input" 
                type="password" 
                placeholder="Repite tu contraseña" 
                value={confirm} 
                onChange={e => setConfirm(e.target.value)} 
                required 
              />
           </div>
           
           <button className="btn btn-v btn-full btn-lg mt-8" disabled={loading}>
              {loading ? 'Guardando...' : 'Restablecer Contraseña'}
           </button>
           
           <button 
             type="button" 
             className="btn btn-ghost btn-full mt-3" 
             onClick={() => nav('/')}
           >
              Cancelar
           </button>
         </form>
      </div>
    </div>
  );
}
